// extracted by mini-css-extract-plugin
export default {"auth_container":"auth_auth_container__ou9Bf","authentication_desktop_logo":"auth_authentication_desktop_logo__82lO-"};